/** The Firmark logo mark — three ascending chevrons. Inherits color via
 *  `currentColor` by default so it works on light and dark surfaces. */
export function FirmarkMark({
  size = 22,
  color = "currentColor",
  strokeWidth = 3.5,
}: {
  size?: number;
  color?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 52 52"
      aria-hidden="true"
      style={{ display: "block", flexShrink: 0 }}
    >
      <path d="M21 17 L26 12 L31 17" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 26 L26 16 L36 26" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 35 L26 25 L41 35" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
